module.exports = __webpack_public_path__ + "img/optik_s.62d8a08c.svg";